/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, Suspense } from "react";
import ChunkErrorBoundary from "./ChunkErrorBoundary";
import {
  Layout,
  Typography,
  Card,
  Tag,
  Spin } from
"antd";
import {
  useDefaultPageTitle,
  TITLE_SUFFIX } from
"../../context/PageTitleContext";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { useAuthDispatch } from "../../context/AuthContext";
import { useLocation } from "react-router-dom";
import StaffDashboard from "./StaffDashboard";
import roleService, { ROLES } from "../../service/RoleService";



// --- Lazy-loaded page components (code-split) ---
const LayoutProject = React.lazy(() => import("../../Layout/index-project"));
const LayoutFinance = React.lazy(() => import("../../Layout/index-finances"));
const LayoutAdminFinance = React.lazy(
  () => import("../../Layout/index-admin-finances")
);
const XeroDashboard = React.lazy(() => import("../Finance/XeroDashboard"));
const AIToolsIndex = React.lazy(() => import("../AITools"));
const AboutMediatropy = React.lazy(() => import("../CompanyDirectory/About"));
const CompanyOffice = React.lazy(() => import("../CompanyDirectory/Office"));
const CompanyTeam = React.lazy(() => import("../CompanyDirectory/Team"));
const CompanyDepartment = React.lazy(
  () => import("../CompanyDirectory/Department")
);
const CompanyOrganization = React.lazy(
  () => import("../CompanyDirectory/Organization")
);
const ClientDetailPage = React.lazy(
  () => import("../ProjectManagement/Clients/ClientDetailPage")
);
const ClientContactDetailPage = React.lazy(
  () => import("../ProjectManagement/Contacts/ClientContactDetailPage")
);
const VendorDetailPage = React.lazy(
  () => import("../ProjectManagement/Vendors/VendorDetailPage")
);
const PICDetailPage = React.lazy(
  () => import("../ProjectManagement/PIC/PICDetailPage")
);
const ProjectDetailPage = React.lazy(
  () => import("../ProjectManagement/Projects/ProjectDetailPage")
);
const FeedbackTemplateDetail = React.lazy(
  () => import("../ProjectManagement/Feedback/FeedbackTemplateDetail")
);
const InvoiceInvestigationPage = React.lazy(
  () => import("../ProjectManagement/Invoice/InvoiceInvestigationPage")
);
const VendorBillDetailPage = React.lazy(
  () => import("../Finance/VendorBills/VendorBillDetailPage")
);
const SalesOrderDetailPage = React.lazy(
  () => import("../Finance/SalesOrders/SalesOrderDetailPage")
);
const InvoiceDetailPage = React.lazy(
  () => import("../Finance/ClientInvoices/InvoiceDetailPage")
);
const ExpenseRequestDetailPage = React.lazy(
  () => import("../Finance/ExpenseRequests/ExpenseRequestDetailPage")
);
const ChatbotThreads = React.lazy(() => import("../Chatbot/ChatbotThreads"));
const ChatbotSections = React.lazy(
  () => import("../Chatbot/Section/ChatbotSections")
);
const SectionDetails = React.lazy(
  () => import("../Chatbot/Section/SectionDetails")
);
const CompanyPrompts = React.lazy(
  () => import("../Chatbot/Company/CompanyPrompts")
);
const DepartmentPrompt = React.lazy(
  () => import("../Chatbot/Department/DepartmentPrompt")
);
const TaskRouter = React.lazy(() => import("../Tasks/TaskRouter"));
const RecruitmentRouter = React.lazy(
  () => import("../Recruitment/RecruitmentRouter")
);
const Timesheet = React.lazy(() => import("../Timesheet"));
const Training = React.lazy(() => import("../Training"));
const CourseDetail = React.lazy(() => import("../Training/CourseDetail"));
const CourseQuiz = React.lazy(() => import("../Training/CourseQuiz"));
const QuizResult = React.lazy(() => import("../Training/QuizResult"));
const NotificationPage = React.lazy(() => import("../Notification"));
const Announcements = React.lazy(() => import("../Announcements"));
const AnnouncementAdmin = React.lazy(() => import("../Announcements/AnnouncementAdmin"));
const Newsfeed = React.lazy(() => import("../Newsfeed"));
const ManageNewsfeed = React.lazy(() => import("../Newsfeed/ManageNewsfeed"));
const APIUsageIndexPage = React.lazy(
  () => import("../APIUsageAnalysis/APIUsageIndexPage")
);
const AIUsageAnalysisPage = React.lazy(
  () => import("../APIUsageAnalysis/AIUsageAnalysisPage")
);
const CurrencyUsageAnalysisPage = React.lazy(
  () => import("../APIUsageAnalysis/CurrencyUsageAnalysisPage")
);
const XeroUsageAnalysisPage = React.lazy(
  () => import("../APIUsageAnalysis/XeroUsageAnalysisPage")
);
const QnA = React.lazy(() => import("../QnA"));
const CalendarPage = React.lazy(() => import("../Calendar"));
const Knowledgebase = React.lazy(() => import("../Knowledgebase"));
const CompanyPoliciesPage = React.lazy(() => import("../Knowledgebase/CompanyPoliciesPage"));
const CompanyPolicyReaderPage = React.lazy(() => import("../Knowledgebase/CompanyPolicyReaderPage"));
const SustainabilityCdpPage = React.lazy(() => import("../Knowledgebase/SustainabilityCdpPage"));
const ProfilePage = React.lazy(() => import("../Profile"));
const PublicProfile = React.lazy(() => import("../Profile/PublicProfile"));
const DevLogin = React.lazy(() => import("../DevLogin"));
const WFA = React.lazy(() => import("../WFA"));
const WFAFormPage = React.lazy(() => import("../WFA/WFAFormPage"));
const AdminWFA = React.lazy(() => import("../WFA/AdminWFA"));
const LeavesRouter = React.lazy(() => import("../Leaves"));
const AdminLeaves = React.lazy(() => import("../Leaves/AdminLeaves"));
const AppraisalUserView = React.lazy(() => import("../Appraisal/AppraisalUserView"));
const AppraisalDetail = React.lazy(() => import("../Appraisal/AppraisalDetail"));
const AppraisalAdmin = React.lazy(() => import("../Appraisal"));
const SurveyAdmin = React.lazy(() => import("../Survey"));
const SurveyInbox = React.lazy(() => import("../Survey/SurveyInbox"));
const WorkplaceFeedbackForm = React.lazy(() => import("../WorkplaceFeedback/WorkplaceFeedbackForm"));
const WorkplaceFeedbackAdmin = React.lazy(() => import("../WorkplaceFeedback/WorkplaceFeedbackAdmin"));
const TrainingAdmin = React.lazy(() => import("../TrainingAdmin"));
const AwardsAdmin = React.lazy(() => import("../AwardsAdmin"));
const KnowledgebaseAdmin = React.lazy(() => import("../KnowledgebaseAdmin"));
const PolicySendSchedulerPage = React.lazy(() => import("../KnowledgebaseAdmin/PolicySendSchedulerPage"));
const HRDashboard = React.lazy(() => import("../HR/HRDashboard"));
const DashboardDetailPage = React.lazy(
  () => import("../HR/Dashboard/pages/DashboardDetailPage")
);
const ActivityLog = React.lazy(() => import("../Admin/ActivityLog"));
const VendorBillProcessingPage = React.lazy(
  () => import("../Admin/VendorBillProcessing/VendorBillProcessingPage")
);
const NotFoundPage = React.lazy(() => import("../NotFound"));
const ApiKeyManagement = React.lazy(
  () => import("../ApiKeyManagement/ApiKeyManagement")
);
const EmailManagement = React.lazy(() => import("../Admin/EmailManagement"));
const EmailTemplateEditorPage = React.lazy(
  () => import("../Admin/EmailManagement/EmailTemplateEditorPage")
);
const EmailBanner = React.lazy(() => import("../Settings/EmailBanner"));
const SignatureTemplate = React.lazy(
  () => import("../Settings/SignatureTemplate")
);
const WikiRouter = React.lazy(() => import("../Wiki/WikiRouter"));
const AIPromptManagement = React.lazy(() =>
import("../Admin/AIPromptManagement").then((m) => ({
  default: m.AIPromptManagement
}))
);
const NotificationManagement = React.lazy(() =>
import("../Admin/NotificationManagement").then((m) => ({
  default: m.NotificationManagement
}))
);
const ProcessExperimentation = React.lazy(() => import("../Admin/ProcessExperimentation"));
const AnalyticsPage = React.lazy(() => import("../Analytics/AnalyticsPage"));
const AssetManagement = React.lazy(() => import("../Asset/AssetManagement"));
const ManageAccount = React.lazy(
  () => import("../ManageAccount/ManageAccount")
);

const { Content } = Layout;
const { Title, Text } = Typography;

// Placeholder component for unimplemented features
const PlaceholderComponent = ({ name }) =>
<div
  style={{
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    minHeight: "calc(100vh - 64px)"
  }}>
  
        <Card style={{ padding: 40, textAlign: "center", maxWidth: 500 }}>
            <Title level={3}>{name}</Title>
            <Text type="secondary">
                This feature is currently under development.
            </Text>
        </Card>
    </div>;


const HomeContent = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  const cookies = new Cookies();
  const user = cookies.get("userR");
  useAuthDispatch();

  // Check if we're in production environment






  // Extract section from path
  let section = null;
  let subSection = null;
  let detailId = null;

  if (path === "/" || path === "/home") {
    section = "dashboard";
  } else if (path.startsWith("/company-directory/")) {
    section = path.replace("/company-directory/", "");
  } else if (path === "/ai-tools") {
    section = "AI-tools";
  } else if (path === "/project-management") {
    section = "project-management";
  } else if (
  path.startsWith("/finances/expense-requests/") &&
  path.split("/").length === 4)
  {
    // Expense Request detail page: /finances/expense-requests/:id or /finances/expense-requests/new
    section = "expense-request-detail";
    detailId = path.split("/")[3];
  } else if (
  path.startsWith("/finances/vendor-bills/") &&
  path.split("/").length === 4)
  {
    // Vendor Bill detail page: /finances/vendor-bills/:id
    section = "vendor-bill-detail";
    detailId = path.split("/")[3];
  } else if (
  path.startsWith("/finances/sales-order/") &&
  path.split("/").length === 4)
  {
    // Sales Order detail page: /finances/sales-order/:id
    section = "sales-order-detail";
    detailId = path.split("/")[3];
  } else if (
  path.startsWith("/finances/invoice/") &&
  path.split("/").length === 4)
  {
    // Client Invoice detail page: /finances/invoice/:id
    section = "invoice-detail";
    detailId = path.split("/")[3];
  } else if (path === "/finances") {
    section = "finances";
  } else if (path.startsWith("/project-management/")) {
    // Handle detail pages for new route structure
    const parts = path.split("/");
    if (parts[2] === "client" && parts[3]) {
      section = "client-detail";
      detailId = parts[3];
    } else if (parts[2] === "contact" && parts[3]) {
      section = "contact-detail";
      detailId = parts[3];
    } else if (parts[2] === "vendor" && parts[3]) {
      section = "vendor-detail";
      detailId = parts[3];
    } else if (parts[2] === "pic" && parts[3]) {
      section = "pic-detail";
      detailId = parts[3];
    } else if (parts[2] === "project" && parts[3]) {
      section = "project-detail";
      detailId = parts[3];
    } else if (
    parts[2] === "feedback" &&
    parts[3] === "template" &&
    parts[4])
    {
      section = "feedback-template-detail";
      detailId = parts[4];
    } else if (parts[2] === "invoice" && parts[3]) {
      section = "invoice-investigation";
      detailId = decodeURIComponent(parts[3]);
    }
  } else if (path.startsWith("/tasks")) {
    section = "tasks";
  } else if (path.startsWith("/wiki")) {
    section = "wiki";
  } else if (path.startsWith("/chatbot")) {
    section = "chatbot";
    if (path === "/chatbot/section") {
      subSection = "sections";
    } else if (path.startsWith("/chatbot/section/")) {
      subSection = "section-details";
    } else if (path === "/chatbot/company-prompt") {
      subSection = "company-prompts";
    } else if (path === "/chatbot/department-prompt") {
      subSection = "department-prompts";
    } else {
      subSection = "threads";
    }
  } else if (path === "/admin/user-impersonator") {
    section = "admin-user-impersonator";
  } else if (path === "/admin/activity-log") {
    section = "activity-log";
  } else if (path === "/admin/vendor-bill-processing") {
    section = "vendor-bill-processing";
  } else if (
    path === "/admin/aspire-invoice-allocation" ||
    path === "/admin/tech-platform-vendor-bill-buffer"
  ) {
    section = (
      roleService.canAccessAspireInvoiceAllocation() ||
      roleService.hasRole("ROLE_TEAM_LEADER") ||
      roleService.hasRole("ROLE_OWNER") ||
      roleService.hasRole("ROLE_SUPER_ADMIN")
    ) ? "vendor-bill-processing" : "not-found";
  } else if (path === "/admin/api-key-management") {
    section = "api-key-management";
  } else if (path === "/admin/email-management") {
    section = "email-management";
  } else if (path === "/admin/ai-prompts") {
    section = "ai-prompt-management";
  } else if (path === "/admin/process-improvement") {
    section = "process-experimentation";
  } else if (path === "/admin/notifications") {
    section = "notification-management";
  } else if (path === "/admin/newsfeed") {
    section = "newsfeed-admin";
  } else if (path === "/admin/announcements") {
    section = "announcement-admin";
  } else if (path.startsWith("/admin/email-management/template/")) {
    section = "email-template-editor";
    detailId = path.split("/")[4];
  } else if (path === "/admin/email-banner" || path === "/settings/email-banner" || path === "/settings/email/banner") {
    section = "email-banner";
  } else if (path === "/admin/email-signature-template" || path === "/settings/email/signature-template") {
    section = "email-signature-template";
  } else if (
  path.startsWith("/admin/finances/expense-requests/") &&
  path.split("/").length === 5)
  {
    section = "admin-expense-request-detail";
    detailId = path.split("/")[4];
  } else if (path === "/admin/finances") {
    section = "admin-finances";
  } else if (path === "/admin/xero") {
    section = "admin-xero";
  } else if (path === "/admin/qna") {
    section = "admin-qna";
  } else if (path.match(/^\/admin\/hr\/working-location\/(new|\d+)$/)) {
    // Admin WFA detail page: /admin/hr/working-location/new or /admin/hr/working-location/:id
    section = "hr-working-location-detail";
    detailId = path.split("/").pop();
  } else if (path === "/admin/hr/dashboard/detail") {
    section = "hr-dashboard-detail";
  } else if (path.startsWith("/admin/hr/")) {
    // Extract the section without the tab parameter
    const adminPath = path.replace("/admin/hr/", "");
    const adminSection = adminPath.split("/")[0]; // Get only the first part (e.g., "leaves" from "leaves/calendar")
    section = `hr-${adminSection}`;
  } else if (path.startsWith("/course/")) {
    // Remove query parameters from path for parsing
    const cleanPath = path.split("?")[0];
    const parts = cleanPath.split("/");
    if (parts[2] && parts[3] === "quiz" && parts[4] === "result") {
      section = "course-quiz-result";
      detailId = parts[2];
    } else if (parts[2] && parts[3] === "quiz") {
      section = "course-quiz";
      detailId = parts[2];
    } else if (parts[2]) {
      section = "course-detail";
      detailId = parts[2];
    }
  } else if (path === "/notification" || path === "/notifications") {
    section = "notification";
  } else if (path === "/newsfeed") {
    section = "newsfeed";
  } else if (path === "/announcements") {
    section = "announcements";
  } else if (path === "/workplace-feedback") {
    section = "workplace-feedback";
  } else if (path === "/admin/api-usage") {
    section = "api-usage";
  } else if (path === "/admin/api-usage/ai-general") {
    section = "api-usage-ai";
  } else if (path === "/admin/api-usage/currency") {
    section = "api-usage-currency";
  } else if (path === "/admin/api-usage/xero") {
    section = "api-usage-xero";
  } else if (path.startsWith("/admin/knowledgebase/policy-send/")) {
    section = "knowledgebase-policy-send";
  } else if (path === "/admin/knowledgebase") {
    section = "knowledgebase-admin";
  } else if (path.startsWith("/knowledgebase/company-policies/")) {
    section = "company-policy-reader";
  } else if (path === "/knowledgebase/company-policies") {
    section = "company-policies";
  } else if (path === "/knowledgebase/sustainability-cdp") {
    section = "sustainability-cdp";
  } else if (path.match(/^\/knowledgebase\/\d+$/)) {
    section = "knowledgebase";
    detailId = path.split("/")[2]; // folderId
  } else if (path === "/knowledgebase") {
    section = "knowledgebase";
  } else if (path === "/calendar") {
    section = "calendar";
  } else if (path === "/profile") {
    section = "profile";
  } else if (
  path.startsWith("/profile/user/") ||
  path.match(/^\/profile\/\d+/))
  {
    const parts = path.split("/");
    section = "profile";
    detailId = parts[parts.length - 1]; // Get last part (userId)
  } else if (path.startsWith("/wfa/") && path.split("/").length === 3) {
    // WFA detail page: /wfa/new or /wfa/:id
    section = "wfa-detail";
    detailId = path.split("/")[2];
  } else if (path === "/wfa") {
    section = "wfa";
  } else if (path === "/admin/manage-account") {
    section = "manage-account";
  } else if (path.startsWith("/appraisal/") && path.split("/").length === 3) {
    section = "appraisal-detail";
    detailId = path.split("/")[2];
  } else if (path === "/appraisal") {
    section = "appraisals";
  } else {
    // Extract section from path
    section = path.substring(1).split("/")[0];
  }

  // Page title mapping for all sections
  const PAGE_TITLES = {
    // Main sections
    dashboard: "Dashboard",
    analytics: "Analytics",
    "project-management": "Project Management",
    finances: "Finances",
    recruitment: "Recruitment",
    tasks: "Tasks",
    wiki: "Wiki",
    timesheet: "Timesheet",
    training: "Learning & Development",
    calendar: "Calendar",
    notification: "Notifications",
    notifications: "Notifications",
    newsfeed: "Newsfeed",
    announcements: "Announcements",
    surveys: "My Surveys",
    "workplace-feedback": "Share Workplace Feedback with HR",
    "api-usage": "API Usage Analysis",
    "api-usage-ai": "AI Usage Analysis",
    "api-usage-currency": "Currency API Analysis",
    "api-usage-xero": "Xero API Analysis",
    "knowledgebase-admin": "Knowledgebase Settings",
    "knowledgebase-policy-send": "Send Company Policy",
    "company-policies": "Company Policies",
    "sustainability-cdp": "Sustainability & CDP",
    knowledgebase: "Knowledgebase",
    profile: "My Profile",
    "public-profile": "User Profile",
    appraisals: "My Appraisals",
    "appraisal-detail": "Appraisal",

    // Company Directory
    about: "About Mediatropy",
    office: "Office Directory",
    team: "Team Directory",
    department: "Department Directory",
    organization: "Organization Chart",

    // AI & Chatbot
    "AI-tools": "AI Tools",
    chatbot: "AI Chat",

    // Detail pages (default titles - components can override with specific names)
    "client-detail": "Client Details",
    "contact-detail": "Contact Details",
    "vendor-detail": "Vendor Details",
    "pic-detail": "PIC Details",
    "project-detail": "Project Details",
    "feedback-template-detail": "Feedback Template",
    "invoice-investigation": "Invoice Investigation",
    "not-found": "Page Not Found",
    "expense-request-detail": "Expense Request",
    "admin-expense-request-detail": "Expense Request",
    "vendor-bill-detail": "Vendor Bill Details",
    "sales-order-detail": "Sales Order Details",
    "invoice-detail": "Invoice Details",
    "course-detail": "Course Details",
    "course-quiz": "Course Quiz",
    "course-quiz-result": "Quiz Results",

    // Admin sections
    "admin-finances": "Finance Administration",
    "admin-xero": "Xero Dashboard",
    "admin-qna": "Q&A Management",
    "admin-user-impersonator": "User Impersonator",
    "activity-log": "Activity Log",
    "aspire-invoice-allocation": "Aspire Invoice Allocation",
    "tech-platform-vendor-bill-buffer": "Tech Platform Bill Buffer",
    "vendor-bill-processing": "Vendor Bill Processing",
    "api-key-management": "API Key Management",
    "email-management": "Email Management",
    "email-template-editor": "Email Template Editor",
    "ai-prompt-management": "AI Prompt Management",
    "process-experimentation": "Process Improvement",
    "notification-management": "Notification Management",
    "newsfeed-admin": "Manage Newsfeed",
    "announcement-admin": "Manage Announcements",
    "email-banner": "Email Banners",
    "email-signature-template": "Signature Templates",

    // HR sections
    "hr-appraisals": "HR - Appraisals",
    "hr-surveys": "HR - Surveys",
    "hr-workplace-feedback": "HR - Workplace Feedback",
    "hr-dashboard": "HR - Dashboard",
    "hr-leaves": "HR - Leaves",
    "hr-recruitment": "HR - Recruitment",
    "hr-asset": "HR - Computers & Equipment",
    "hr-trainings": "HR - Training",
    "hr-awards": "HR - Awards",
    "hr-flexible-work": "HR - Flexible Work",
    "hr-working-location": "HR - MT Anywhere+",
    "hr-working-location-detail": "WFA Request",

    // Other
    wfa: "Work From Anywhere",
    "wfa-detail": "WFA Request",
    qa: "Q&A"
  };

  // Chatbot subsection titles
  const CHATBOT_TITLES = {
    threads: "AI Chat",
    sections: "Chat Sections",
    "section-details": "Section Details",
    "image-generation": "AI Image Generation",
    "company-prompts": "Company Prompts",
    "department-prompts": "Department Prompts"
  };

  // Set page title based on current section
  const { setDefaultTitle } = useDefaultPageTitle();

  useEffect(() => {
    let title = "Mediatropy HR";

    if (section === "chatbot" && subSection) {
      title = CHATBOT_TITLES[subSection] || "AI Chat";
    } else if (section && PAGE_TITLES[section]) {
      title = PAGE_TITLES[section];
    }

    // Append suffix for branding (uses constant from PageTitleContext)
    setDefaultTitle(`${title}${TITLE_SUFFIX}`);
  }, [section, subSection, setDefaultTitle]);

  // Get user title and department
  const getUserTitle = () => {
    // Check if user has management role
    const isManagement =
    user?.roles?.includes("ROLE_MANAGEMENT") ||
    user?.roles?.includes("ROLE_ADMIN") ||
    user?.roles?.includes("ROLE_OWNER");

    // Handle title - it should now always be a string or null from the API
    if (user?.title && user.title !== "null" && user.title !== null) {
      return user.title;
    }

    // For management roles without a title, show "Director"
    if (isManagement) {
      return "Director";
    }

    return "Position not set";
  };

  const getUserDepartment = () => {
    // Get office location (cookie stores office as numeric ID, so resolve name if available)
    let officeName = null;
    if (user?.office) {
      if (typeof user.office === "object" && user.office !== null) {
        officeName = user.office.full_name || user.office.name || null;
      } else if (typeof user.office === "string") {
        officeName = user.office;
      }
      // numeric office_id — no name available from cookie
    }

    const withOffice = (dept) => officeName ? `${dept} in ${officeName}` : dept;

    // Check if user has management role
    const isManagement =
    user?.roles?.includes("ROLE_MANAGEMENT") ||
    user?.roles?.includes("ROLE_ADMIN") ||
    user?.roles?.includes("ROLE_OWNER");

    if (
    isManagement && (
    !user?.department || user?.department === "Department not set"))
    {
      return withOffice("Management Department");
    }

    // Handle department - it might be an object or a string
    if (user?.department) {
      // If department is an object, get the name property and add "Department" suffix
      if (
      typeof user.department === "object" &&
      user.department !== null)
      {
        const deptName = user.department.name || "Unknown";
        return withOffice(`${deptName} Department`);
      }
      // If it's a string, add "Department" suffix if not already there
      if (!user.department.includes("Department")) {
        return withOffice(`${user.department} Department`);
      }
      return withOffice(user.department);
    }
    return "Department not set";
  };

  // Pages with gray background (#f0f2f5)
  const grayBackgroundPaths = [
  "/",
  "/home",
  "/notification",
  "/notifications",
  "/newsfeed",
  "/announcements",
  "/workplace-feedback",
  "/surveys",
  "/knowledgebase",
  "/profile",
  "/admin/hr/dashboard",
  "/admin/hr/dashboard/detail",
  "/admin/newsfeed",
  "/admin/hr/workplace-feedback"];


  // Render dashboard
  const renderDashboard = () =>
  <StaffDashboard
    user={user}
    userTitle={getUserTitle()}
    userDepartment={getUserDepartment()}
    isTeamLeaderOrAbove={
      roleService.isManager() &&
      !roleService.hasAnyDirectRole([
        ROLES.ROLE_OWNER,
        ROLES.ROLE_MANAGEMENT,
        ROLES.ROLE_SUPER_ADMIN,
      ])
    }
    onNavigate={navigate} />;


  // Render the appropriate content based on the section
  const renderContent = () => {
    if (!section || section === "dashboard") {
      return renderDashboard();
    }

    // Handle detail views
    if (detailId) {
      switch (section) {
        case "client-detail":
          return <ClientDetailPage clientId={detailId} />;
        case "contact-detail":
          return <ClientContactDetailPage contactId={detailId} />;
        case "vendor-detail":
          return <VendorDetailPage vendorId={detailId} />;
        case "pic-detail":
          return <PICDetailPage picId={detailId} />;
        case "project-detail":
          return <ProjectDetailPage projectId={detailId} />;
        case "feedback-template-detail":
          return <FeedbackTemplateDetail templateId={detailId} />;
        case "invoice-investigation":
          return <InvoiceInvestigationPage />;
        default:
          break;
      }
    }

    // Handle regular sections
    switch (section) {
      case "about":
        return <AboutMediatropy />;
      case "office":
        return <CompanyOffice />;
      case "team":
        return <CompanyTeam />;
      case "department":
        return <CompanyDepartment />;
      case "organization":
        return <CompanyOrganization />;
      case "AI-tools":
        return <AIToolsIndex />;
      case "calendar":
        return <CalendarPage />;
      case "recruitment":
        return <RecruitmentRouter />;
      case "leaves":
        return <LeavesRouter />;
      case "appraisals":
        return <AppraisalUserView />;
      case "appraisal-detail":
        return <AppraisalDetail />;
      case "project-management":
        return <LayoutProject />;
      case "tasks":
        return <TaskRouter />;
      case "wiki":
        return <WikiRouter />;
      case "timesheet":
        return <Timesheet />;
      case "finances":
        return <LayoutFinance />;
      case "expense-request-detail":
        return <ExpenseRequestDetailPage />;
      case "admin-expense-request-detail":
        return <ExpenseRequestDetailPage />;
      case "vendor-bill-detail":
        return <VendorBillDetailPage />;
      case "sales-order-detail":
        return <SalesOrderDetailPage />;
      case "invoice-detail":
        return <InvoiceDetailPage />;
      case "chatbot":
        if (subSection === "threads") {
          return <ChatbotThreads />;
        } else if (subSection === "sections") {
          return <ChatbotSections />;
        } else if (subSection === "section-details") {
          return <SectionDetails />;
        } else if (subSection === "company-prompts") {
          return <CompanyPrompts />;
        } else if (subSection === "department-prompts") {
          return <DepartmentPrompt />;
        }
        return <ChatbotThreads />;
      case "training":
        return <Training />;
      case "course-detail":
        return <CourseDetail />;
      case "course-quiz":
        return <CourseQuiz />;
      case "course-quiz-result":
        return <QuizResult />;
      case "notification":
      case "notifications":
        return <NotificationPage />;
      case "newsfeed":
        return <Newsfeed />;
      case "announcements":
        return <Announcements />;
      case "surveys":
        return <SurveyInbox />;
      case "workplace-feedback":
        return <WorkplaceFeedbackForm />;
      case "api-usage":
        return <APIUsageIndexPage />;
      case "api-usage-ai":
        return <AIUsageAnalysisPage />;
      case "api-usage-currency":
        return <CurrencyUsageAnalysisPage />;
      case "api-usage-xero":
        return <XeroUsageAnalysisPage />;
      case "qa":
        return <QnA />;
      case "knowledgebase-admin":
        return <KnowledgebaseAdmin />;
      case "knowledgebase-policy-send":
        return <PolicySendSchedulerPage />;
      case "company-policies":
        return <CompanyPoliciesPage />;
      case "company-policy-reader":
        return <CompanyPolicyReaderPage />;
      case "sustainability-cdp":
        return <SustainabilityCdpPage />;
      case "knowledgebase":
        return <Knowledgebase folderId={detailId} />;
      case "profile":
        return <ProfilePage />;
      case "public-profile":
        return <PublicProfile />;
      case "wfa":
        return <WFA />;
      case "wfa-detail":
        return <WFAFormPage />;
      case "hr-appraisals":
        return <AppraisalAdmin />;
      case "hr-surveys":
        return <SurveyAdmin />;
      case "hr-workplace-feedback":
        return <WorkplaceFeedbackAdmin />;
      case "hr-dashboard-detail":
        return <DashboardDetailPage />;
      case "hr-dashboard":
        return <HRDashboard />;
      case "hr-leaves":
        return <AdminLeaves />;
      case "hr-recruitment":
        return <RecruitmentRouter />;
      case "hr-asset":
        return <AssetManagement />;
      case "hr-trainings":
        return <TrainingAdmin />;
      case "hr-awards":
        return <AwardsAdmin />;
      case "hr-flexible-work":
        return (
          <PlaceholderComponent name="HR - Flexible Work Arrangement" />);

      case "hr-working-location":
        return <AdminWFA />;
      case "hr-working-location-detail":
        return <WFAFormPage isAdmin />;
      case "admin-finances":
        // Admin Finance view - requires ROLE_FINANCE or ROLE_MANAGEMENT
        return <LayoutAdminFinance />;
      case "admin-xero":
        // Xero Dashboard - requires ROLE_OWNER or ROLE_CAN_SWITCH_USER
        return <XeroDashboard />;
      case "admin-qna":
        // Admin Q&A view - requires ROLE_HR, ROLE_MANAGEMENT, or ROLE_SUPER_ADMIN
        return <QnA />;
      case "admin-user-impersonator":
        return <DevLogin />;
      case "activity-log":
        return <ActivityLog />;
      case "not-found":
        return <NotFoundPage />;
      case "vendor-bill-processing":
        return <VendorBillProcessingPage />;
      case "analytics":
        return <AnalyticsPage />;
      case "api-key-management":
        return <ApiKeyManagement />;
      case "email-management":
        return <EmailManagement />;
      case "ai-prompt-management":
        return <AIPromptManagement />;
      case "process-experimentation":
        return <ProcessExperimentation />;
      case "notification-management":
        return <NotificationManagement />;
      case "newsfeed-admin":
        return <ManageNewsfeed />;
      case "announcement-admin":
        return <AnnouncementAdmin />;
      case "email-template-editor":
        return <EmailTemplateEditorPage />;
      case "email-banner":
        return <EmailBanner />;
      case "email-signature-template":
        return <SignatureTemplate />;
      case "manage-account":
        return <ManageAccount />;
      default:
        return <PlaceholderComponent name={section} />;
    }
  };

  const isAppraisalPath =
  path === "/appraisal" ||
  path.startsWith("/appraisal/");

  return (
    <>
            {/* Dev/Test indicator */}
            <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          zIndex: 1000
        }}>
        
                {process.env.NODE_ENV === "development" &&
        !cookies.get("isImpersonating") &&
        <Tag color="orange">DEV/TEST</Tag>
        }
            </div>

            <Content
        style={{
          background:
          grayBackgroundPaths.includes(path) ||
          path.startsWith("/surveys/") ||
          path === "/notification" ||
          path === "/announcements" ?
          "#f0f2f5" :
          isAppraisalPath ?
          "#f5f5f5" :
          path === "/knowledgebase" ||
          path.startsWith("/knowledgebase/company-policies") ||
          path === "/knowledgebase/sustainability-cdp" ||
          path === "/admin/knowledgebase" ||
          path.startsWith("/admin/knowledgebase/policy-send/") ||
          path === "/admin/qna" ||
          path === "/admin/activity-log" ||
          path === "/admin/vendor-bill-processing" ||
          path === "/admin/aspire-invoice-allocation" ||
          path === "/admin/tech-platform-vendor-bill-buffer" ||
          path === "/admin/api-key-management" ||
          path === "/admin/email-management" ||
          path.startsWith(
            "/admin/email-management/template/"
          ) ||
          path === "/admin/email-banner" ||
          path === "/settings/email-banner" ||
          path === "/settings/email/banner" ||
          path === "/admin/email-signature-template" ||
          path === "/settings/email/signature-template" ||
          path === "/admin/newsfeed" ||
          path === "/admin/announcements" ?
          "#f5f5f5" :
          "#fff",
          minHeight: "calc(100vh - 64px)",
          padding:
          path === "/knowledgebase" ||
          path.startsWith("/knowledgebase/company-policies") ||
          path === "/knowledgebase/sustainability-cdp" ||
          path === "/admin/knowledgebase" ||
          path.startsWith("/admin/knowledgebase/policy-send/") ||
          path === "/admin/qna" ||
          path === "/admin/activity-log" ||
          path === "/admin/vendor-bill-processing" ||
          path === "/admin/aspire-invoice-allocation" ||
          path === "/admin/tech-platform-vendor-bill-buffer" ||
          path === "/admin/api-key-management" ||
          path === "/admin/email-management" ||
          path.startsWith("/admin/email-management/template/") ||
          path === "/admin/email-banner" ||
          path === "/settings/email-banner" ||
          path === "/settings/email/banner" ||
          path === "/admin/email-signature-template" ||
          path === "/settings/email/signature-template" ||
          path === "/" ||
          path === "/home" ||
          path === "/notification" ||
          path === "/newsfeed" ||
          path === "/announcements" ||
          path === "/admin/newsfeed" ||
          path === "/workplace-feedback" ||
          path === "/admin/announcements" ||
          path === "/admin/user-impersonator" ||
          path === "/admin/api-usage" ||
          path === "/admin/hr/dashboard" ||
          path === "/admin/hr/dashboard/detail" ||
          path === "/admin/hr/workplace-feedback" ||
          path === "/profile" ||
          path.startsWith("/profile/") ||
          path.startsWith("/surveys/") ||
          path.startsWith("/admin/api-usage/") ?
          0 :
          isAppraisalPath ?
          "1rem 24px 16px" :
          undefined
        }}
        className={
        path.includes("/finances") ||
        path.includes("/admin/hr/leaves") ||
        path.includes("/admin/hr/working-location") ||
        path.includes("/admin/hr/recruitment") ||
        path.includes("/leaves") ||
        path.includes("/project-management") ||
        path.includes("/tasks") ||
        path.includes("/wiki") ||
        path.includes("/company-directory/office") ||
        path.includes("/company-directory/team") ||
        path.includes("/company-directory/department") ||
        path.includes("/company-directory/organization") ||
        path.includes("/timesheet") ||
        path.includes("/training") ||
        path.includes("/course/") ||
        path.includes("/admin/hr/asset") ||
        path.includes("/admin/hr/appraisals") ||
        path.includes("/admin/hr/workplace-feedback") ||
        path.includes("/admin/hr/surveys") ?
        "project-content-layout" :
        path === "/ai-tools" ?
        "ai-tools-content-layout" :
        ""
        }>
        
                <ChunkErrorBoundary resetKey={`${location.pathname}${location.search}`}>
                    <Suspense
            fallback={
            <Spin
              size="large"
              style={{
                display: "block",
                margin: "100px auto"
              }} />

            }>
            
                        {renderContent()}
                    </Suspense>
                </ChunkErrorBoundary>
            </Content>
        </>);

};

export default HomeContent;
